export enum FieldDefaultNameEnum {
  Number = 'Number',
  Number2 = 'Number2',
  Description1 = 'Description1',
  Description2 = 'Description2',
  Description3 = 'Description3',
  Description4 = 'Description4',
  Description5 = 'Description5',
  Description6 = 'Description6',
  Description7 = 'Description7',
  Description8 = 'Description8',
  Description9 = 'Description9',
  Structure = 'Structure',
  CreatedOn = 'CreatedOn',
  ModifiedOn = 'ModifiedOn',
  Creator = 'Creator',
  Modifier = 'Modifier',
  Attribute_Name1 = 'Attribute'
}
